import React, { Fragment, useEffect, useRef, useState } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Row,
  Table,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Alert,
  Button,
  Label,
  ButtonDropdown,
  Form,
  FormGroup,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  CardTitle,
  CardText,
} from "reactstrap";
import withReducer from "../../../store/withReducer";
import partnerReducer from "../store";
import Breadcrumbs from "../../../layout/breadcrumb";
import DatePicker from "../../../share-components/ui/DateRangePicker";
import { DateRangePicker } from "rsuite";
import Select from "react-select";
import BackInStockTable from "../../backInStock/content/backInStockTable";
import { useDispatch, useSelector } from "react-redux";
import CommonDataTable from "../../../share-components/table/commonDataTable";
import OrderReturnSec from "../content/OrderReturnSec";
import OrdersNotFound from "../content/OrdersNotFound";
import ModalFormSubmit from "../../../share-components/form/modalFormSubmit";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  addInvoiceItemDecision,
  closeAppDecDialog,
  emailSendingStatementReconciliationDetails,
  exportStatementReconciliationDetails,
  getStatementReconciliationDetails,
  getStatementReconsiliationSettings,
  getStatementReconsiliationSummary,
  getUnmatchedData,
  openAppDecDialog,
  setReconciliationVal,
  setStatementReconciliationSummary,
} from "../store/partnerSlice";
import ApproveDeclineForm from "../content/ApproveDeclineform";
import CustomModal from "../../../share-components/modal";
import moment from "moment";
import { toast } from "react-toastify";

const statusOptions = [
  { value: 1, label: "SKU Mismatch" },
  { value: 2, label: "Price Mismatch" },
  { value: 3, label: "Quantity Mismatch" },
  { value: 4, label: "Refunded Status Mismatch" },
];

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: 50,
    border: "none",
  }),
};

const customMultiStyles = {
  ...customStyles,

  multiValue: (base) => ({
    ...base,
    backgroundColor: "#656E78",
    color: "#fff",
    // borderRadius: "4px",
    padding: "2px 4px",
  }),

  multiValueLabel: (base) => ({
    ...base,
    color: "#fff",
    fontWeight: 500,
  }),

  multiValueRemove: (base) => ({
    ...base,
    color: "#fff",
    ":hover": {
      backgroundColor: "#333",
      color: "#fff",
    },
  }),
};

const styles = { minHeight: "50px !important", border: "none !important", display: "block", paddingLeft: 0 };

const defaultValues = {};

const schema = {};

function StatementReconciliationDetails() {
  const { id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const partner = queryParams.get("partner");
  const batch_id = queryParams.get("batch");
  const start_date = queryParams.get("start_date");
  const end_date = queryParams.get("end_date");

  const dispatch = useDispatch();
  const { handleSubmit, formState, reset, control, register, setValue, handleChange, trigger, getValues } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(schema),
  });
  const { errors } = formState;

  const partnerState = useSelector(({ partner }) => partner.partner);
  const TodayDate = new Date();
  const sevenDays = new Date().setDate(TodayDate.getDate() - 90);
  const [dateRange, setDateRange] = useState([null, null]);
  const [dispatchDateRange, setDispatchDateRange] = useState([null, null]);
  const [returnDateRange, setReturnDateRange] = useState([null, null]);
  const [actionDropdownOpen, setActionDropdownOpen] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);
  const [status, setStatus] = useState();
  const [searchOrderId, setSearchOrderId] = useState("");
  const [search, setSearch] = useState("");
  const [timer, setTimer] = useState(null);
  const [orderCheckBoxData, setOrderCheckBoxData] = useState({ idArray: [] , orderIds : [], activeTab : 0});
  const [buttonDisable, setButtonDisable] = useState(false);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [salesPage, setSalesPage] = useState(1);
  const [salesPageSize, setSalesPageSize] = useState(10);
  const [returnsPage, setReturnsPage] = useState(1);
  const [returnsPageSize, setreturnsPageSize] = useState(10);
  const [startDate, endDate] = dateRange;
  const [dispatchStartDate, dispatchEndDate] = dispatchDateRange;
  const [returnStartDate, returnEndDate] = returnDateRange;
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [salesReturnLoading, setSalesReturnLoadinge] = useState(false);
  const [unMatchLoading, setUnMatchLoadinge] = useState(false);
  const [changeInvoiceLoading, setChangeInvoiceLoadinge] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const isDateInitialized = useRef(false);

  const summaryStartDate = partnerState.statementReconciliationSummary?.startDate
    ? moment(partnerState.statementReconciliationSummary.startDate).toDate()
    : null;

  const summaryEndDate = partnerState.statementReconciliationSummary?.endDate
    ? moment(partnerState.statementReconciliationSummary.endDate).toDate()
    : null;

  let idArray = [];
  const dataMenu = [
    {
      type: 1,
      text: "Statement Reconciliation",
      link: "/order/statement-reconciliation",
    },
    {
      type: 0,
      text: "Statement Reconciliation Details",
    },
  ];

  useEffect(() => {
    if (summaryStartDate && summaryEndDate && !isDateInitialized.current) {
      setDateRange([summaryStartDate, summaryEndDate]);
      isDateInitialized.current = true;
    }
  }, [summaryStartDate, summaryEndDate]);

  useEffect(() => {
    dispatch(getStatementReconsiliationSettings()).then((res) => {
      dispatch(setReconciliationVal(res.payload));
    });
  }, [dispatch]);

  useEffect(() => {
    if (startDate && endDate && partner && batch_id) {
      getData();
    }
  }, [
    dispatch,
    salesPage,
    salesPageSize,
    returnsPage,
    returnsPageSize,
    startDate,
    endDate,
    partner,
    batch_id,
    dispatchStartDate,
    dispatchEndDate,
    returnStartDate,
    returnEndDate,
    status,
    searchOrderId,
    search,
    changeInvoiceLoading
  ]);

  useEffect(() => {
    if (startDate && endDate && partner && batch_id) {
      getUnMatchedData();
    }
  }, [dispatch, page, pageSize, startDate, endDate, partner, batch_id]);

  useEffect(() => {
    if (partner && batch_id && start_date && end_date) {
      const data = {
        partner,
        batch_id,
        start_date,
        end_date,
      };
      setSummaryLoading(true);
      dispatch(getStatementReconsiliationSummary(data)).then((res) => {
        setSummaryLoading(false);
        dispatch(setStatementReconciliationSummary(res.payload.data));
      });
    }
  }, [dispatch, partner, batch_id, start_date, end_date]);

  const getData = () => {
    const statusIds = status ? status.map((s) => s.value).join(",") : null;

    const data = {
      partner,
      batch_id,
      start_date: moment(startDate).format("YYYY-MM-DD"),
      end_date: moment(endDate).format("YYYY-MM-DD"),
      salesPage,
      salesPageSize,
      returnsPage,
      returnsPageSize,
      ...(dispatchStartDate && {
        dispatch_start_date: moment(dispatchStartDate).format("YYYY-MM-DD"),
      }),
      ...(dispatchEndDate && {
        dispatch_end_date: moment(dispatchEndDate).format("YYYY-MM-DD"),
      }),
      ...(returnStartDate && {
        return_start_date: moment(returnStartDate).format("YYYY-MM-DD"),
      }),
      ...(returnEndDate && {
        return_end_date: moment(returnEndDate).format("YYYY-MM-DD"),
      }),
      ...(statusIds && { status: statusIds }),
      ...(searchOrderId && { order_id: searchOrderId }),
      ...(search && { search: search }),
    };
    setSalesReturnLoadinge(true);
    dispatch(getStatementReconciliationDetails(data)).then((res) => {
      setSalesReturnLoadinge(false);
    });
  };

  const getUnMatchedData = () => {
    const data = {
      partner,
      batch_id,
      start_date: moment(startDate).format("YYYY-MM-DD"),
      end_date: moment(endDate).format("YYYY-MM-DD"),
      page,
      pageSize,
    };
    setUnMatchLoadinge(true);
    dispatch(getUnmatchedData(data)).then((res) => {
      setUnMatchLoadinge(false);
    });
  };

  // console.log("summaryLoading", summaryLoading);
  // console.log("partnerState", partnerState);

  const actionToggle = () => setActionDropdownOpen((prevState) => !prevState);

  const onSubmitForm = (dialog, data) => {};

  const closeDialog = () => {
    dispatch(closeAppDecDialog());
  };

  const handleApprove = () => {
    const data = {
      isApprove: true,
    };
    dispatch(openAppDecDialog(data));
  };

  const handleDecline = () => {
    const data = {
      isApprove: false,
    };
    dispatch(openAppDecDialog(data));
  };

  const handleApproveDecline = (data) => {
    const ids = orderCheckBoxData.orderIds;
    const salesOrReturn = orderCheckBoxData.activeTab;

    const formData = {
      ids,
      partner,
      batch_id,
      salesOrReturn : Number(salesOrReturn), // 1 Sales // 2 Return
      reason: data.selectReason?.id,
      approveBy: data.selectUser?.value,
      isApprove: data.status === 1 ? true : false,
      isDecline: data.status === 2 ? true : false,
    };

    setChangeInvoiceLoadinge(true);
    setBtnDisable(true)
    dispatch(addInvoiceItemDecision(formData)).then((res) => {
      setChangeInvoiceLoadinge(false);
      setBtnDisable(false)
      closeDialog();
      setOrderCheckBoxData({
        idArray: [],
        orderIds: [],
        activeTab: salesOrReturn,
      });
      if (res.payload.success) {
        toast.success(`${res.payload.message}`);
      } else {
        toast.error(`${res.payload.message}`);
      }
    });
  };

  const handleExport = () => {

    const exportIds = orderCheckBoxData.orderIds;
    const salesOrReturn = orderCheckBoxData.activeTab;
    
    const data ={
      exportIds,
      salesOrReturn : Number(salesOrReturn), // 1 Sales // 2 Return
      batch_id,
    }

    setExportLoading(true)
    const outputFilename = `Statement_Reconciliation_Exports${new Date().toJSON().slice(0, 10)}.csv`;
    dispatch(exportStatementReconciliationDetails({ ...data })).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.payload]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", outputFilename);
      document.body.appendChild(link);
      link.click();
      setExportLoading(false);
    });
  };

  const handleSendEmail = () => {
    const exportIds = orderCheckBoxData.orderIds;
    const salesOrReturn = orderCheckBoxData.activeTab;
    
    const data ={
      exportIds,
      salesOrReturn : Number(salesOrReturn), // 1 Sales // 2 Return
      batch_id,
    }

    setBtnDisable(true)
    dispatch(emailSendingStatementReconciliationDetails({ ...data })).then((res) => {
      setBtnDisable(false);
    });
  };

  return (
    <Fragment>
      <Breadcrumbs title="Statement Reconciliation Details" data={dataMenu} />
      <div className="product-grid">
        <div className="feature-products">
          <Card>
            <CardBody style={{ padding: 20 }}>
              <Row>
                <Col>
                  <div className="d-flex align-items-center">
                    <Label className="mb-0" style={{ fontWeight: 600 }}>
                      Marketplace Name :
                    </Label>
                    <Label className="mb-0" style={{ marginLeft: 5, fontWeight: 600, color: "#3b3a3acf" }}>
                      {partnerState.statementReconciliationSummary?.marketplaceName}
                    </Label>
                  </div>
                </Col>
                <Col>
                  <div className="d-flex align-items-center">
                    <Label className="mb-0" style={{ fontWeight: 500 }}>
                      File Imported By :
                    </Label>
                    <Label className="mb-0" style={{ marginLeft: 5, fontWeight: 600, color: "#3b3a3acf" }}>
                      {partnerState.statementReconciliationSummary?.fileImportedBy}
                    </Label>
                  </div>
                </Col>
                <Col>
                  <div className="d-flex align-items-center">
                    <Label className="mb-0" style={{ fontWeight: 500 }}>
                      Imported File :
                    </Label>
                    <Label className="mb-0" style={{ marginLeft: 5, fontWeight: 600, color: "#3b3a3acf" }}>
                      <a
                        href={partnerState.statementReconciliationSummary?.importedFile}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontSize: "14px", color: "#007bff" }}
                      >
                        <span>
                          <i className="fa fa-download"></i> Download File
                        </span>
                      </a>
                    </Label>
                  </div>
                </Col>
                <Col>
                  <div className="d-flex align-items-center">
                    <Label className="mb-0" style={{ fontWeight: 500 }}>
                      Start Date :
                    </Label>
                    <Label className="mb-0" style={{ marginLeft: 5, fontWeight: 600, color: "#3b3a3acf" }}>
                      {moment(partnerState.statementReconciliationSummary?.startDate).format("YYYY-MM-DD") ?? null}
                    </Label>
                  </div>
                </Col>
                <Col>
                  <div className="d-flex align-items-center">
                    <Label className="mb-0" style={{ fontWeight: 500 }}>
                      End Date :
                    </Label>
                    <Label className="mb-0" style={{ marginLeft: 5, fontWeight: 600, color: "#3b3a3acf" }}>
                      {moment(partnerState.statementReconciliationSummary?.endDate).format("YYYY-MM-DD") ?? null}
                    </Label>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Card>
            <CardBody style={{ padding: 10 }}>
              <Row>
                <Col sm={3}>
                  <div className="dashboard-datepicker p-2">
                    <p style={{ marginBottom: 0, marginLeft: 17, fontSize: 16, fontWeight: 500, color: "#b0abab" }}>Order Date</p>
                    <DateRangePicker
                      size="lg"
                      style={styles}
                      appearance="subtle"
                      placeholder="Select Date Range"
                      className="form-control hide-border-control"
                      character=" - "
                      format="dd/MM/yyyy"
                      value={dateRange}
                      disabledDate={(date) => date < summaryStartDate || date > summaryEndDate}
                      onChange={(update) => {
                        setDateRange(update);
                      }}
                      cleanable={false}
                      disabled={salesReturnLoading}
                    />
                  </div>
                </Col>
                <Col sm={3}>
                  <div className="dashboard-datepicker p-2">
                    <p style={{ marginBottom: 0, marginLeft: 17, fontSize: 16, fontWeight: 500, color: "#b0abab" }}>Dispatch Date</p>
                    <DateRangePicker
                      size="lg"
                      appearance="subtle"
                      placeholder="Select Dispatch Date"
                      className="form-control hide-border-control"
                      character=" - "
                      format="dd/MM/yyyy"
                      value={dispatchDateRange}
                      onChange={(update) => {
                        setDispatchDateRange(update);
                      }}
                      disabledDate={(date) => date < summaryStartDate || date > summaryEndDate}
                      cleanable={true}
                      disabled={salesReturnLoading}
                    />
                  </div>
                </Col>
                <Col sm={3}>
                  <div className="dashboard-datepicker p-2">
                    <p style={{ marginBottom: 0, marginLeft: 17, fontSize: 16, fontWeight: 500, color: "#b0abab" }}>Return Date</p>
                    <DateRangePicker
                      size="lg"
                      appearance="subtle"
                      placeholder="Select Return Date"
                      className="form-control hide-border-control"
                      character=" - "
                      format="dd/MM/yyyy"
                      value={returnDateRange}
                      onChange={(update) => {
                        setReturnDateRange(update);
                      }}
                      disabledDate={(date) => date < summaryStartDate || date > summaryEndDate}
                      cleanable={true}
                      disabled={salesReturnLoading}
                    />
                  </div>
                </Col>
                <Col className="d-flex align-items-center justify-content-end">
                  {orderCheckBoxData.idArray.length > 0 && (
                    <ButtonDropdown isOpen={actionDropdownOpen} toggle={actionToggle}>
                      <DropdownToggle caret color="success" className="btn btn-success btn-square" disabled={btnDisable}>
                        {btnDisable ? ( // Show the spinner if loading state is true
                          <span>
                            {" "}
                            <i className="fa fa-spinner fa-spin fa-lg spinner mr-1" /> Action
                          </span>
                        ) : (
                          "Action" // Show the regular text if loading state is false
                        )}
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem onClick={handleApprove}>Approve Selected Orders</DropdownItem>
                        <DropdownItem onClick={handleDecline}>Decline Selected Orders</DropdownItem>
                        <DropdownItem onClick={handleSendEmail}>Send Email to Marketplace</DropdownItem>
                      </DropdownMenu>
                    </ButtonDropdown>
                  )}

                  <Button
                    type="button"
                    color="primary"
                    className="ml-3"
                    disabled={exportLoading || orderCheckBoxData.idArray.length === 0}
                    onClick={handleExport}
                  >
                    <i className={exportLoading ? "fa fa-spinner fa-spin mr-1" : "fa fa-download mr-1"}></i>
                    Export
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Row>
            <Col sm={3}>
              <Select
                placeholder="Select Status"
                className="select2-filter"
                // getOptionLabel={(option) => option.name}
                // getOptionValue={(option) => option.id}
                isMulti
                isClearable
                options={statusOptions}
                styles={customMultiStyles}
                onChange={(selected) => {
                  setStatus(selected);
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                // isDisabled={salesReturnLoading}
              />
            </Col>
            <Col sm={3}>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                <FormGroup className="m-0">
                  <Input
                    type="text"
                    className="form-control"
                    defaultValue={searchOrderId}
                    onChange={(e) => {
                      clearTimeout(timer);
                      const newTimer = setTimeout(() => {
                        setSearchOrderId(e.target.value);
                      }, 500);
                      setTimer(newTimer);
                    }}
                    placeholder="Search Order Id"
                    // disabled={salesReturnLoading}
                  />
                  <i className="fa fa-search"></i>
                </FormGroup>
              </Form>
            </Col>
            <Col sm={6}>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                <FormGroup className="m-0">
                  <Input
                    type="text"
                    className="form-control"
                    defaultValue={search}
                    onChange={(e) => {
                      clearTimeout(timer);
                      const newTimer = setTimeout(() => {
                        setSearch(e.target.value);
                      }, 500);
                      setTimer(newTimer);
                    }}
                    placeholder="Search Product Style / SKU"
                    // disabled={salesReturnLoading}
                  />
                  <i className="fa fa-search"></i>
                </FormGroup>
              </Form>
            </Col>
          </Row>

          <Row>
            <Col>
              <Card className="p-2">
                <div className="d-flex flex-column align-items-end">
                  <p className="mb-0" style={{ fontWeight: 500 }}>
                    Total Marketplace Records
                  </p>
                  <p className="my-0" style={{ fontSize: 18 }}>
                    <strong>{partnerState.statementReconciliationSummary?.totalMarketPlaceRecords ?? "--"}</strong>
                  </p>
                </div>
              </Card>
            </Col>
            <Col>
              <Card className="p-2">
                <div className="d-flex flex-column align-items-end">
                  <p className="mb-0" style={{ fontWeight: 500 }}>
                    Total Excel File Records
                  </p>
                  <p className="my-0" style={{ fontSize: 18 }}>
                    <strong> {partnerState.statementReconciliationSummary?.totalExcelFileRecords ?? "--"}</strong>
                  </p>
                </div>
              </Card>
            </Col>
            <Col>
              <Card className="p-2">
                <div className="d-flex flex-column align-items-end">
                  <p className="mb-0" style={{ fontWeight: 500 }}>
                    SKU Mismatches
                  </p>
                  <p className="my-0" style={{ fontSize: 18, color: "#DC0000" }}>
                    <strong> {partnerState.statementReconciliationSummary?.skuMismatchRecords ?? "--"}</strong>
                  </p>
                </div>
              </Card>
            </Col>
            <Col>
              <Card className="p-2">
                <div className="d-flex flex-column align-items-end">
                  <p className="mb-0" style={{ fontWeight: 500 }}>
                    Price Mismatches
                  </p>
                  <p className="my-0" style={{ fontSize: 18, color: "#DC0000" }}>
                    <strong> {partnerState.statementReconciliationSummary?.priceMismatchRecords ?? "--"}</strong>
                  </p>
                </div>
              </Card>
            </Col>
            <Col>
              <Card className="p-2">
                <div className="d-flex flex-column align-items-end">
                  <p className="mb-0" style={{ fontWeight: 500 }}>
                    Quantity Mismatches
                  </p>
                  <p className="my-0" style={{ fontSize: 18, color: "#DC0000" }}>
                    <strong> {partnerState.statementReconciliationSummary?.quantityMismatchRecords ?? "--"}</strong>
                  </p>
                </div>
              </Card>
            </Col>
            <Col>
              <Card className="p-2">
                <div className="d-flex flex-column align-items-end">
                  <p className="mb-0" style={{ fontWeight: 500 }}>
                    Refund Status Mismatches
                  </p>
                  <p className="my-0" style={{ fontSize: 18, color: "#DC0000" }}>
                    <strong>{partnerState.statementReconciliationSummary?.refundStatusMismatchRecords ?? "--"}</strong>
                  </p>
                </div>
              </Card>
            </Col>
            <Col>
              <Card className="p-2">
                <div className="d-flex flex-column align-items-end">
                  <p className="mb-0" style={{ fontWeight: 500 }}>
                    Items Not Founds
                  </p>
                  <p className="my-0" style={{ fontSize: 18, color: "#DC0000" }}>
                    <strong> {partnerState.statementReconciliationSummary?.orderNotFounds ?? "--"}</strong>
                  </p>
                </div>
              </Card>
            </Col>
            <Col>
              <Card className="p-2">
                <div className="d-flex flex-column align-items-end">
                  <p className="mb-0" style={{ fontWeight: 500 }}>
                    Missing Items
                  </p>
                  <p className="my-0" style={{ fontSize: 18, color: "#DC0000" }}>
                    <strong> {partnerState.statementReconciliationSummary?.missingOrders ?? "--"}</strong>
                  </p>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <div>
        <OrderReturnSec
          orderCheckBoxData={orderCheckBoxData}
          setOrderCheckBoxData={setOrderCheckBoxData}
          partnerState={partnerState}
          salesPage={salesPage}
          setSalesPage={setSalesPage}
          salesPageSize={salesPageSize}
          setSalesPageSize={setSalesPageSize}
          returnsPage={returnsPage}
          setReturnsPage={setReturnsPage}
          returnsPageSize={returnsPageSize}
          setreturnsPageSize={setreturnsPageSize}
          salesReturnLoading={salesReturnLoading}
        />
      </div>

      <div>
        <OrdersNotFound
          partnerState={partnerState}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          unMatchLoading={unMatchLoading}
        />
      </div>

      <CustomModal
        size="lg"
        title="Approve Selected Orders"
        dialog={(state) => {
          return state.partner.partner.appDecDialog;
        }}
        closeDialog={closeDialog}
      >
        <ApproveDeclineForm partnerState={partnerState} onHandleSubmit={handleApproveDecline} changeInvoiceLoading={changeInvoiceLoading} />
      </CustomModal>
    </Fragment>
  );
}

export default withReducer([{ partner: partnerReducer }])(StatementReconciliationDetails);
